
export var UOMUtil = {
	
	roundDistance(amount) {
		var value = amount ? amount : 0;
		return Math.round(value * 10) / 10;
	},
	
	sumFinalDistance(distances) {
		var totalDistance = 0;
		if (distances) {
			distances.forEach(function(d) {
				var finalDistance = d.finalDistance;
				if (finalDistance && finalDistance.distance) {
					totalDistance += finalDistance.distance;
				}
			});
		}
		return UOMUtil.roundDistance(totalDistance);
	},
	
	sumStopDistance(stopDistance) {
		if (!stopDistance || !stopDistance.distances) {
			return 0;
		}
		return UOMUtil.sumFinalDistance(stopDistance.distances);
	},
	
	sumTripStopDistances(trip) {
		var totalDistance = 0;
		if (trip && trip.stops) {
			trip.stops.forEach(function(stop) {
				if (stop.stopDistance && stop.stopDistance.distances) {
					stop.stopDistance.distances.forEach(function(d) {
						var finalDistance = d.finalDistance;
						if (finalDistance && finalDistance.distance) {
							totalDistance += finalDistance.distance;
						}
					});
				}
			});
		}
		return UOMUtil.roundDistance(totalDistance);
	},
	
	convertLitersToGallons(amount) {
		var newValue = 0;
		if (amount) {
			newValue = amount * 0.264172;
			newValue = Math.round(newValue * 10) / 10;
		}
		return newValue;
	},
	
	convertKMToMI(amount) {
		var newValue = 0;
		if (amount) {
			newValue = amount * 0.621371;
			newValue = Math.round(newValue * 10) / 10;
		}
		return newValue;
	}
	
};

